import queryString from 'query-string';
import url from 'url';

export const getQSObject = () => {
  return queryString.parse(window.location.search);
};

export const getQSFromURL = (urlstr) => {
  const search = url.parse(urlstr, true).query;
  return search;
};

export const getQSObjectFromLocation = (location) => {
  return queryString.parse(location.search);
};

export const getValueOfQSObject = (obj, key) => {
  return obj[key];
};
